import { Component, OnInit, OnDestroy, Renderer2, Inject, DOCUMENT } from '@angular/core';
import { Subscription } from 'rxjs';
import {Router} from '@angular/router';


@Component({
    selector: 'app-chatbot-modal',
    templateUrl: './chatbot-modal.component.html',
    styleUrls: ['./chatbot-modal.component.scss'],
    standalone: false
})
export class ChatbotModalComponent implements OnInit {
  labels;
  labelsSub: Subscription;

  private scriptElement: HTMLScriptElement;
  private linkElement: HTMLLinkElement;

  constructor(
              private router: Router,
              private renderer: Renderer2,
              @Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {

  }

  ngOnDestroy(): void {

  }

}
